export default "__VITE_ASSET__Bs2toJze__"